var categorySquareFeetPrice = document.getElementById(
  "category_squarefeet_price"
).value;

var special_size_id = 50971051622719; // Replace with your actual product variant ID for special_size rugs

// Array of custom rug product IDs - replace with your actual product variant IDs
var custom_rug_ids = [
    50971040514367,
    51067463139647,
    51067469005119,
    51067471200575,
    51067475067199
  ];

async function getNextAvailableCustomRugId() {
  const cart = await fetch('/cart.js').then(res => res.json());
  const cartVariantIds = cart.items.map(item => item.variant_id);
  for (let id of custom_rug_ids) {
    if (!cartVariantIds.includes(id)) {
      return id;
    }
  }
  return null;
}

function hasAvailableCustomRugIds() {
  return custom_rug_ids.length > 0;
}

function isCustomRugId(productId) {
  return custom_rug_ids.includes(parseInt(productId));
}

function showError(message) {
  var container = document.querySelector('.cost-section .price-section');
  if (!container) {
    alert(message);
    return;
  }
  var oldMsg = container.querySelector('.custom-error-message');
  if (oldMsg) oldMsg.remove();
  var msg = document.createElement('div');
  msg.className = 'custom-error-message';
  msg.textContent = message;
  msg.style.color = 'red';
  container.appendChild(msg);
  setTimeout(() => { msg.remove(); }, 5000);
}

/* ---------------------------------------------------------------------------
 * Custom-rug minimum price gate.
 *
 * A made-to-order rug below the minimum is not worth producing, so the Custom
 * Size form's Add to Cart is disabled and a notice is shown until the rug is
 * priced at or above it. The threshold is PER RUG (before quantity) and comes
 * from the theme setting `custom_rug_min_price`, surfaced on .product-quote as
 * data-custom-rug-min. Set it to 0 to switch the limit off.
 *
 * Only the Custom Size form is gated - the Special Size block is untouched.
 * ------------------------------------------------------------------------- */

var crQuoteShown = false;

/**
 * Value of custom rugs already in the cart, in dollars.
 * The minimum applies to the order as a whole, so once the cart already holds
 * enough custom-rug value the limit is satisfied and further custom rugs may be
 * any price. Refreshed on load and again immediately before an add, so the
 * decisive check never runs on stale cart data.
 */
var crCartCustomTotal = 0;

async function crFetchCartCustomTotal() {
  try {
    var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (custom_rug_ids.indexOf(item.variant_id) !== -1) {
        var cents = item.final_line_price != null ? item.final_line_price : item.line_price;
        total += (cents || 0) / 100;
      }
    });
    crCartCustomTotal = total;
  } catch (e) {
    crCartCustomTotal = 0;
  }
  return crCartCustomTotal;
}

function crMinPrice() {
  var host = document.querySelector('.product-quote');
  var v = host ? parseFloat(host.dataset.customRugMin) : NaN;
  return isNaN(v) ? 0 : v;
}

function crMinMessage() {
  var host = document.querySelector('.product-quote');
  var m = host && host.dataset.customRugMinMessage;
  return m || 'Minimum order for a custom rug is $' + crMinPrice();
}

/** Per-rug price (excludes quantity, includes the saver discount). */
function crUnitPrice() {
  var w = parseFloat(document.getElementById('width').value);
  var l = parseFloat(document.getElementById('length').value);
  var delivery = document.getElementById('deliveryTime').value;
  if (isNaN(w) || isNaN(l) || !(categorySquareFeetPrice > 0)) return NaN;
  var unit = ((w * l) / 144) * categorySquareFeetPrice;
  return delivery === '2' ? unit * 0.8 : unit;
}

/** @returns {boolean} true when the rug may be added. */
function crMinPriceOk(unitPrice) {
  var min = crMinPrice();
  if (!(min > 0)) return true;
  // Already enough custom-rug value in the cart -> the minimum is met, so a
  // smaller add-on rug is fine.
  if (crCartCustomTotal >= min) return true;
  if (isNaN(unitPrice)) return false;
  return unitPrice >= min;
}

/** Enable/disable Add to Cart and show/hide the notice. */
function crApplyMinPriceGate(unitPrice) {
  var btn = document.getElementById('quote-addtocart');
  var notice = document.getElementById('custom-rug-min-notice');
  if (typeof unitPrice === 'undefined') unitPrice = crUnitPrice();

  var blocked = !crMinPriceOk(unitPrice);

  if (btn) {
    btn.disabled = blocked;
    btn.classList.toggle('is-disabled', blocked);
    btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
  }
  if (notice) {
    notice.textContent = blocked ? crMinMessage() : '';
    notice.hidden = !blocked;
  }
  return !blocked;
}

/**
 * Busy state for the Custom Size "Add to Cart" button.
 * Adding a custom rug is slow — the pricing service has to reprice the
 * placeholder product and the result is then verified — so without feedback the
 * button looks dead and invites a second click.
 * @param {boolean} on
 */
function crSetAddLoading(on) {
  var btn = document.getElementById('quote-addtocart');
  if (!btn) return;

  // Reuse the theme's own button loading style (.btn--primary.is-loading draws
  // its spinner via ::before/::after and fades the label). Clicks are stopped
  // with pointer-events rather than [disabled], which would grey the button out
  // and read as "unavailable" instead of "working".
  if (on) {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
  } else {
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    // Hand control back to the minimum-price gate rather than blindly enabling.
    crApplyMinPriceGate();
  }
}

/**
 * Live handler for the Custom Size fields. Once a quote has been shown, any
 * edit re-prices and re-runs the gate immediately - no page reload and no need
 * to press Get Quote again. Before the first quote it behaves as before.
 */
function onCustomSizeChange() {
  if (!crQuoteShown) {
    resetForm();
    return;
  }
  var w = parseFloat(document.getElementById('width').value);
  var l = parseFloat(document.getElementById('length').value);
  var q = parseFloat(document.getElementById('quote_qty').value);
  if (isNaN(w) || w < 1 || isNaN(l) || l < 1 || isNaN(q) || q < 1) {
    resetForm();
    crQuoteShown = false;
    crApplyMinPriceGate(NaN);
    return;
  }
  calculatePrice();
}

// Re-price as the shopper types, not only on blur/change.
document.addEventListener('DOMContentLoaded', function () {
  ['width', 'length', 'quote_qty'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', onCustomSizeChange);
  });
  // Existing custom rugs in the cart can already satisfy the minimum.
  crFetchCartCustomTotal().then(function () {
    if (crQuoteShown) crApplyMinPriceGate();
  });
});

function toggleQuoteSection() {
  const quoteSection = document.querySelector(".quote-section");
  quoteSection.classList.toggle("hidden");
}

// Toggle custom size section
function toggleSection() {
  var section = document.querySelector(".section-size");
  var showMore = document.querySelector(".show-more");
  var showLess = document.querySelector(".show-less");
  var totalSection = document.querySelector(".total");

  section.classList.toggle("hidden");
  showMore.classList.toggle("hidden");
  showLess.classList.toggle("hidden");
  totalSection.classList.add("hidden");
}

function scrollToCustomForm() {
  const form = document.getElementById("custom-size-form");
  if (form) {
    form.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

// Reset form when inputs change
function resetForm() {
  document.querySelector(".total").classList.add("hidden");
  document.getElementById("quote-price").innerText = "";
  document.getElementById("real_price").innerText = "";
  document.getElementById("discount_text").innerText = "";
}

// Validate inputs
function validateInputs() {
  var isValid = true;

  // Validate width
  var width = parseFloat(document.getElementById("width").value);
  if (isNaN(width) || width < 1) {
    document.getElementById("width-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("width-error").style.display = "none";
  }

  // Validate length
  var length = parseFloat(document.getElementById("length").value);
  if (isNaN(length) || length < 1) {
    document.getElementById("length-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("length-error").style.display = "none";
  }

  // Validate quantity
  var qty = parseFloat(document.getElementById("quote_qty").value);
  if (isNaN(qty) || qty < 1) {
    document.getElementById("quote_qty-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("quote_qty-error").style.display = "none";
  }

  return isValid;
}

// Calculate price for custom size
function calculatePrice() {
  if (categorySquareFeetPrice <= 0) {
    alert("Pricing information not available. Please contact us for a quote.");
    return;
  }

  if (!validateInputs()) {
    return;
  }

  var widthInches = parseFloat(document.getElementById("width").value);
  var lengthInches = parseFloat(document.getElementById("length").value);
  var qty = parseFloat(document.getElementById("quote_qty").value);
  var deliveryTime = document.getElementById("deliveryTime").value;

  // Calculate square feet (convert from square inches)
  var squareFeet = (widthInches * lengthInches) / 144;
  var priceTotal = squareFeet * categorySquareFeetPrice;
  var priceWithQty = priceTotal * qty;

  // Apply discount if selected
  if (deliveryTime === "2") {
    var discountValue = (priceWithQty / 100) * 20;
    var discountedPrice = priceWithQty - discountValue;

    document.getElementById("real_price").innerText =
      "$" + priceWithQty.toFixed(2);
    document.getElementById("quote-price").innerText =
      "$" + discountedPrice.toFixed(2);
    document.getElementById("discount_text").innerText = "(20% off)";
    document.getElementById("real_price").style.display = "inline";
    document.getElementById("discount_text").style.display = "inline";
  } else {
    document.getElementById("quote-price").innerText =
      "$" + priceWithQty.toFixed(2);
    document.getElementById("real_price").style.display = "none";
    document.getElementById("discount_text").style.display = "none";
  }

  // Show the total section
  document.querySelector(".total").classList.remove("hidden");
  crQuoteShown = true;

  // Gate Add to Cart on the per-rug price (priceTotal excludes quantity).
  crApplyMinPriceGate(deliveryTime === "2" ? priceTotal * 0.8 : priceTotal);
}

// Update addQuoteToCart to use the new logic and prevent cart redirect
function _crSleep(ms) {
  return new Promise(function (r) { setTimeout(r, ms); });
}

// Reliably price + add a custom / discounted-special rug.
// The pricing service (magento360) rewrites the shared placeholder product's price;
// the previous code then added to cart after a BLIND 2s timeout, so if the reprice
// hadn't propagated the item was added at its stale base price ($0.01). This instead
// awaits the reprice, adds, then VERIFIES the unit price Shopify actually applied and
// retries if it's still wrong — and never leaves a wrong-priced line in the cart.
// Returns true on success, false on failure (cart left clean).
async function addRepricedRugToCart(itemData, expectedUnitCents) {
  var MAX_ATTEMPTS = 4;
  for (var attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    // 1) ask the pricing service to set the placeholder product's price
    try {
      var upd = await fetch("https://magento360.com/app_development/api/update-product.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(itemData),
      });
      if (!upd.ok) throw new Error("update-product HTTP " + upd.status);
    } catch (e) {
      console.error("Custom rug price update failed (attempt " + attempt + "):", e);
      await _crSleep(1200);
      continue;
    }

    // 2) let Shopify propagate the new price, then add
    await _crSleep(1200);
    var added;
    try {
      added = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(itemData),
      }).then(function (r) { return r.json(); });
    } catch (e) {
      console.error("cart/add failed (attempt " + attempt + "):", e);
      await _crSleep(800);
      continue;
    }

    var line = added && added.items ? added.items[0] : added;

    // 3) verify the unit price Shopify charged matches the quote (±1 cent for rounding)
    if (line && typeof line.price === "number" && Math.abs(line.price - expectedUnitCents) <= 1) {
      return true; // correct price locked in
    }

    // wrong / stale price (e.g. $0.01) — remove the bad line and retry
    console.warn("Custom rug price mismatch: got " + (line && line.price) + ", expected " + expectedUnitCents + " — removing & retrying");
    if (line && line.key) {
      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
      } catch (e) { console.error("cleanup remove failed:", e); }
    }
    await _crSleep(1000);
  }
  return false;
}

async function addQuoteToCart() {
  if (!validateInputs()) {
    return;
  }

  const formData = new FormData(document.getElementById("custom-size-form"));
  const widthValue = formData.get("width");
  const lengthValue = formData.get("length");
  const qty = formData.get("quote_qty");
  const deliveryTime = formData.get("deliveryTime");
  const shape = formData.get("shape");

  // Per-rug price from the tier-specific sq-ft rate (categorySquareFeetPrice).
  const squareFeet = (parseFloat(widthValue) * parseFloat(lengthValue)) / 144;
  const squarePrice = squareFeet * parseFloat(categorySquareFeetPrice);
  const unitPrice = deliveryTime === "2" ? squarePrice * 0.8 : squarePrice;
  const expectedUnitCents = Math.round(unitPrice * 100);

  // Never add a rug priced below the minimum, even if the button was
  // re-enabled some other way. Re-read the cart first so the decision is made
  // on current data, not a stale page-load snapshot.
  await crFetchCartCustomTotal();
  if (!crApplyMinPriceGate(unitPrice)) return;

  crSetAddLoading(true);

  // Get the first available custom rug ID not in the cart
  const customRugId = await getNextAvailableCustomRugId();
  if (!customRugId) {
    crSetAddLoading(false);
    showError("You cannot add more than 5 Custom rugs for this product.");
    return;
  }

  const itemData = {
    items: [
      {
        id: customRugId,
        quantity: qty,
        properties: {
          "Rug name": document.querySelector("#active-pattern-title").textContent.trim() + " " + shape + " custom size",
          Width: `${widthValue} inches`,
          Length: `${lengthValue} inches`,
          Shape: shape,
          "Delivery Time": deliveryTime === "2" ? "12-16 weeks (20% discount)" : "4-6 weeks",
          Price: "$" + unitPrice.toFixed(2)
        },
      },
    ],
  };

  const errEl = document.querySelector(".special-size-error");
  if (errEl) errEl.textContent = "";

  const ok = await addRepricedRugToCart(itemData, expectedUnitCents);
  if (!ok) {
    crSetAddLoading(false);
    if (errEl) errEl.textContent = "We couldn't confirm the custom price just now — nothing was added. Please try again.";
    showError("We couldn't confirm the custom price — please try again.");
    return;
  }

  const cart = await fetch("/cart.js").then((res) => res.json());
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = cart.item_count;
  });
  window.location.href = "/cart";
}

function incrementQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  qtyInput.value = parseInt(qtyInput.value) + 1;
  validateQuantity(inputId);
  if (inputId === "size_qty") updateSizePrice();
  else resetForm();
}

function decrementQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  if (parseInt(qtyInput.value) > 1) {
    qtyInput.value = parseInt(qtyInput.value) - 1;
    validateQuantity(inputId);
    if (inputId === "size_qty") updateSizePrice();
    else resetForm();
  }
}

function validateQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  const errorEl = document.getElementById(`${inputId}-error`);

  if (parseInt(qtyInput.value) < 1) {
    if (errorEl) errorEl.style.display = "block";
    qtyInput.value = 1;
  } else {
    if (errorEl) errorEl.style.display = "none";
  }
}

// Price formatting function
function formatPrice(price, format) {
  const precision = format.requiredPrecision || 2;
  const formatted = parseFloat(price).toFixed(precision);
  return format.pattern.replace("%s", formatted);
}

function updateSizePrice() {
  const deliveryTime = document.getElementById("size_deliveryTime").value;
  const qty = parseInt(document.getElementById("size_qty").value) || 1;

  const specialPriceEl = document.querySelector(
    ".special-size-price .special-price"
  );
  const oldPriceEl = document.querySelector(".special-size-price .old-price");
  const discountEl = document.querySelector(".special-size-price .discount");

  // Get base prices (per unit)
  const baseUnitPrice = parseFloat(
    specialPriceEl.getAttribute("data-base-price") ||
      specialPriceEl.getAttribute("data-price")
  );

  // Calculate current total
  const currentTotal = baseUnitPrice * qty;
  let specialPrice = currentTotal;

  // Apply delivery discount if selected
  if (deliveryTime.includes("20% discount")) {
    specialPrice = currentTotal * 0.8;
    discountEl.textContent = "Save 20%";
    oldPriceEl.textContent = formatPrice(
      currentTotal,
      window.productPriceData.priceFormat
    );
    oldPriceEl.setAttribute("data-price", currentTotal.toFixed(2));
  } else {
    const originalUnitPrice = parseFloat(
      oldPriceEl.getAttribute("data-base-price") ||
        oldPriceEl.getAttribute("data-price") ||
        0
    );

    if (originalUnitPrice && originalUnitPrice > baseUnitPrice) {
      const originalPrice = originalUnitPrice * qty;
      const discountPercent = Math.round(
        ((originalPrice - currentTotal) * 100) / originalPrice
      );

      oldPriceEl.textContent = formatPrice(
        originalPrice,
        window.productPriceData.priceFormat
      );
      discountEl.textContent = `Save ${discountPercent}%`;
      oldPriceEl.setAttribute("data-price", originalPrice.toFixed(2));
    } else {
      oldPriceEl.textContent = "";
      oldPriceEl.removeAttribute("data-price");
      discountEl.textContent = "";
    }
  }

  // Update displayed prices
  specialPriceEl.textContent = formatPrice(
    specialPrice,
    window.productPriceData.priceFormat
  );
  specialPriceEl.setAttribute("data-price", specialPrice.toFixed(2));
}

document
  .getElementById("size_deliveryTime")
  ?.addEventListener("change", updateSizePrice);
document
  .getElementById("size_qty")
  ?.addEventListener("change", updateSizePrice);

// Special-size delivery-time rule: same 9'5" (113") cutoff as the custom-size form.
// data-value looks like "9X12" / "7.5X7.5" — the leading number is the width in feet.
function getSizeWidthInches(sizeValue) {
  const match = (sizeValue || "").match(/^([\d.]+)/);
  return match ? parseFloat(match[1]) * 12 : null;
}

function applySizeDeliveryRule(sizeValue) {
  const sizeDeliverySelect = document.getElementById("size_deliveryTime");
  const shortOption = sizeDeliverySelect?.querySelector('option[value="4-6 weeks"]');
  if (!sizeDeliverySelect || !shortOption) return;

  const widthInches = getSizeWidthInches(sizeValue);
  if (widthInches !== null && widthInches >= 113) {
    shortOption.disabled = true;
    shortOption.hidden = true;
    sizeDeliverySelect.value = "12-16 weeks - 20% discount";
  } else {
    shortOption.disabled = false;
    shortOption.hidden = false;
  }
}

// Size selection
document.querySelectorAll('[data-role="size-price"]').forEach((element) => {
  element.addEventListener("click", function () {
    const pid = this.getAttribute("data-pid");
    const baseFinalPrice = this.getAttribute("data-base-final-price");
    const basePrice = this.getAttribute("data-base-price");
    const discount = this.getAttribute("data-discount");

    applySizeDeliveryRule(this.getAttribute("data-value"));

    // Update active state
    document.querySelectorAll('[data-role="size-price"]').forEach((el) => {
      el.classList.remove("active");
    });
    this.classList.add("active");

    // Update product ID
    document
      .getElementById("special-size-addtocart")
      ?.setAttribute("data-pid", pid);

     //special_size_id = pid;

    // Get elements
    const specialPriceEl = document.querySelector(
      ".special-size-price .special-price"
    );
    const oldPriceEl = document.querySelector(".special-size-price .old-price");
    const discountEl = document.querySelector(".special-size-price .discount");

    // Update prices
    specialPriceEl.textContent = formatPrice(
      baseFinalPrice,
      window.productPriceData.priceFormat
    );
    specialPriceEl.setAttribute("data-price", baseFinalPrice);
    specialPriceEl.setAttribute("data-base-price", baseFinalPrice);

    if (discount) {
      oldPriceEl.textContent = formatPrice(
        basePrice,
        window.productPriceData.priceFormat
      );
      oldPriceEl.setAttribute("data-price", basePrice);
      oldPriceEl.setAttribute("data-base-price", basePrice);
      discountEl.textContent = `Save ${discount}%`;
    } else {
      oldPriceEl.textContent = "";
      discountEl.textContent = "";
      oldPriceEl.removeAttribute("data-price");
      oldPriceEl.removeAttribute("data-base-price");
    }

    // Reset quantity and update
    document.getElementById("size_qty").value = 1;
    updateSizePrice();

    console.log(specialPriceEl);
    // added by Wholesale Helper
      try{
        //specialPriceEl.setAttribute("data-wpd-variant-compare-at-price",variant.compare_at_price == null?"":variant.compare_at_price);
        specialPriceEl.setAttribute("data-wpd-variant-price",(parseInt(basePrice))* 100);
        specialPriceEl.setAttribute("data-wpd-variant-id",pid);
        specialPriceEl.setAttribute("data-wpd-variant-id",pid);
        specialPriceEl.setAttribute("data-wpd-product-id", this.getAttribute("data-wpd-product-id"));
        specialPriceEl.setAttribute("data-wpd-product-handle", this.getAttribute("data-wpd-product-handle"));
        specialPriceEl.setAttribute("data-wpd-product-collection-ids", this.getAttribute("data-wpd-product-collection-ids"));
        specialPriceEl.classList.remove("wpd-processed");
      }catch(e){}
    // end of Wholesale Helper code
  });
});

// Add special size to cart
async function addSpecialSizeToCart() {
  const qty = document.getElementById("size_qty").value;
  const shape = document.getElementById("size_shape").value;
  const deliveryTime = document.getElementById("size_deliveryTime").value;
  let price = document
    .querySelector(".special-price")
    .getAttribute("data-price");
  const selectedSize = document.querySelector(
    '[data-role="size-price"].active'
  );
  var special_size_value = selectedSize.getAttribute("data-value");
  var special_size_id = selectedSize.getAttribute("data-pid");

  const unitPrice = parseFloat(price) / parseFloat(qty);
  const expectedUnitCents = Math.round(unitPrice * 100);

  const isDiscounted = deliveryTime != '4-6 weeks';
  let productId = isDiscounted ? 50971051622719 : special_size_id;

  const itemData = {
    items: [
      {
        id: productId,
        quantity: qty,
        properties: {
          "Rug name": document.querySelector("#active-pattern-title").textContent + " " + shape + " Special size",
          "Special Size": special_size_value,
          Shape: shape,
          "Delivery Time": deliveryTime,
          Price: "$" + unitPrice.toFixed(2),
        },
      },
    ],
  };

  const errEl = document.querySelector(".special-size-error");
  if (errEl) errEl.textContent = "";

  if (isDiscounted) {
    // Discounted preset uses the shared placeholder product -> reprice + verify.
    const ok = await addRepricedRugToCart(itemData, expectedUnitCents);
    if (!ok) {
      if (errEl) errEl.textContent = "We couldn't confirm the price just now — nothing was added. Please try again.";
      return;
    }
  } else {
    // 4-6 week preset is a real product at its real price — add directly.
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(itemData),
      }).then((r) => r.json());
    } catch (error) {
      console.error("Error:", error);
      if (errEl) errEl.textContent = "Error adding to cart. Please try again.";
      return;
    }
  }

  window.location.href = "/cart";
}
document.querySelector('[data-role="size-price"]')?.click();

document.addEventListener('DOMContentLoaded', function () {
  const widthInput = document.getElementById('width');
  const deliveryTimeSelect = document.getElementById('deliveryTime');
  const shortDeliveryOption = deliveryTimeSelect?.querySelector('option[value="1"]');

  if (!widthInput || !deliveryTimeSelect) return;

  widthInput.addEventListener('change', function () {
    const widthValue = parseFloat(widthInput.value);
    // Rugs 9'5" (113") wide and above: Saver delivery (12-16 weeks) only
    if (widthValue >= 113) {
      if (shortDeliveryOption) {
        shortDeliveryOption.disabled = true;
        shortDeliveryOption.hidden = true;
      }
      deliveryTimeSelect.value = "2"; // second option
    } else {
      if (shortDeliveryOption) {
        shortDeliveryOption.disabled = false;
        shortDeliveryOption.hidden = false;
      }
      deliveryTimeSelect.value = "1"; // reset to first option
    }
  });
});